export enum CommissionDeltaType {
  overcharge = "overcharge",
  undercharge = "undercharge",
  noGap = "noGap"
}
